import {
    RefObject,
    createRef,
    forwardRef,
    useEffect,
    useState
} from "react";
import infoBg from "../../Assets/homev2/hero-infobar.png";
import { useIntersectionObserver } from "../../hooks";

interface NumberAnimatorProps {
    num: number;
    duration?: number;
}

const NumberAnimator = forwardRef<HTMLDivElement, NumberAnimatorProps>(
    ({ num, duration = 3500 }, ref) => {
        const [newNum, setNewNum] = useState<number>(0);
        const [trigger, setTrigger] = useState(false);
        const entry = useIntersectionObserver(ref as RefObject<Element>, {});
        const isVisible = !!entry?.isIntersecting;

        useEffect(() => {
            if (isVisible) {
                setTrigger(true);
            }
        }, [isVisible]);

        useEffect(() => {
            if (trigger) {
                const numberInterval = setTimeout(
                    () => setNewNum(newNum < num ? newNum + 1 : num),
                    duration / num
                );
                return () => {
                    clearTimeout(numberInterval);
                };
            }
        }, [newNum, trigger]);

        return <>{newNum}</>;
    }
);

const ClientNumbers = () => {
    const ref = createRef<HTMLDivElement>();

    return (
        <div
            className="w-full bottom-0  bg-[length:100%]  md:bg-contain relative fit-content"
            style={{
                backgroundImage: `url('${infoBg}')`,
            }}
            ref={ref}
        >
            <div className=" flex-row max-w-[1400px] mx-auto left-0 flex  lg:flex items-center lg:items-center justify-evenly gap-4  lg:gap-8 md:px-4 py-2 md:py-9 ">
                <div>
                    <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
                        $<NumberAnimator ref={ref} num={37} />M
                    </h2>
                    <h4 className="text-[2vw] whitespace-nowrap font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
                        Client revenue generated
                    </h4>
                </div>
                <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
                <div>
                    <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
                        <NumberAnimator ref={ref} num={10} />
                        K+
                    </h2>
                    <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
                        qualified meetings
                    </h4>
                </div>
                <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
                <div>
                    <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
                        <NumberAnimator ref={ref} num={180} />+
                    </h2>
                    <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
                        satisfied clients{" "}
                    </h4>
                </div>
                <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
                <div>
                    <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
                        <NumberAnimator ref={ref} num={42} />
                    </h2>
                    <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
                        turnkey solutions
                    </h4>
                </div>
            </div>
        </div>
    );
}

export default ClientNumbers;